import TemplateView from 'picnic/core/views/Template';
import Template from 'app/cms/survey/views/Error.html';


class View extends TemplateView {
	get template() {
		return Template;
	}

	get insertMethod() {
		return 'insertAfter';
	}

	get data() {
		return {errorMessages: this.options.errorMessages};
	}
}

export default View;
